<div class="loading-indicator">
    <mat-progress-spinner mode="indeterminate" color="accent"></mat-progress-spinner>
  </div>


// WEBPACK FOOTER //
// ./src/app/busy-spinner/busy-spinner.component.html